export default __webpack_public_path__ + "navigation-examples-route-lines-styling-1200-94d180c46e556dc2a7b5afe85adc5775.png";